import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AccordionState } from 'src/app/shared/accordion/accordion.state';

@Injectable()
export class AccordionService {

  public accordion$: Observable<AccordionState>;
  private subject: Subject<AccordionState>;

  constructor() {
    this.subject = new Subject<AccordionState>();
    this.accordion$ = this.subject.asObservable();
  }

  open(id: string) {
    this.subject.next({ id: id });
  }

  close() {
    this.subject.next({ id: null });
  }
}
